module.exports = "<app-excel-importar-input\r\n    ng-if=\"!$ctrl.data\"\r\n    on-change=\"$ctrl.decodificar($event.data)\"></app-excel-importar-input>\r\n<app-excel-importar-tabla\r\n    ng-if=\"$ctrl.data\"\r\n    data=\"$ctrl.data\"\r\n    headers=\"$ctrl.headers\"\r\n    on-change=\"$ctrl.actualizar($event.data)\"></app-excel-importar-tabla>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/excel/importar/template.html
// module id = 2056
// module chunks = 0